import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Basic.css";
import img from "../../image.png"; // Replace with your image path
export function Header() {
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(false); // Default is logged out
  const [adminName, setAdminName] = useState("Julfecar"); // Replace with dynamic admin name if needed
  const [avatarUrl, setAvatarUrl] = useState(
    "https://lh3.googleusercontent.com/ogw/AF2bZygTWi4awW9RrgVse-3P310BONGURip-rCUxIX604-dYXCw=s32-c-mo"
  ); // Replace with dynamic avatar URL if needed

  // Check if the user is logged in by verifying token in sessionStorage
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    setLoggedIn(!!token); // Set loggedIn based on the presence of a token
  }, []);

  return (
    <header className="header">
      <div className="logo-container" onClick={() => navigate('/')}>
        <img src={img} alt="ManageEdu Logo" className="logo" />
        <h1 className="logo-title">ManageEdu</h1>
      </div>

      <nav className="nav">
        {/* Public Links */}
        <a href="#about">About</a>
        <a href="#how-it-works">How It Works</a>
        <a href="#features">Features</a>
        <a href="#testimonials">Testimonials</a>
        <a href="#contact">Contact</a>
        <Link to="/manageedu/team">Team</Link>
        

        {/* Conditional Links based on login status */}
        {!loggedIn ? (
          <>
            <Link to="/feefix/login">Admin Login</Link>
            <Link to="/feefix/registerOrganization">Register</Link>
            <Link to="/manageedu/student/login">Student Login</Link>
          </>
        ) : (
          <div className="logged-in-nav">
            <Link to="/manageedu/admin">Dashboard</Link>
            <div className="admin-info">
              <img src={avatarUrl} alt="Admin Avatar" className="admin-avatar" />
              <span className="admin-name">Welcome, {adminName}</span>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}

export function Footer() {
  return (
    <footer id="contact" className="footer">
      <div className="footer-content">
        <p>
          Contact us at{" "}
          <a href="mailto:helpmanageedu@gmail.com">helpmanageedu@gmail.com</a>
        </p>
        <p>© 2024 ManageEdu. All rights reserved.</p>
      </div>
    </footer>
  );
}
